import { MenuItem } from '@agro1desenvolvimento/react-components';
import { useScope } from '@agro1desenvolvimento/react-hooks';
import { useLocation, matchPath, Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { find, map } from 'lodash';
import { selectSidebarActive } from '../sidebarSlice';
import MultiNivelMenu from '../MultiNivelMenu';

const MainMenu = () => {
  const location = useLocation();
  const scope = useScope();

  const urlMatches = (path: string) => (
    matchPath(path, { path: location.pathname, exact: true })?.isExact
  );

  const getClassName = (path: string) => (urlMatches(path) ? 'active-route' : undefined);

  const classNameAndTo = (path: string):
    { className: string | undefined, to: string } => (
    { className: getClassName(path), to: path }
  );

  // TODO:  Solução provisoria para ocultar menu de relatórios depois será implementado permissões
  const isAdmin = scope === '-5';
  const items = [
    {
      label: 'Dashboard', icon: 'pi pi-fw pi-chart-bar', ...classNameAndTo('/dashboard'), visible: false,
    },
    {
      label: 'Cadastros',
      icon: 'pi pi-fw pi-list',
      visible: false,
      items: [
        {
          label: 'UBS', icon: 'pi pi-fw pi-map-marker', ...classNameAndTo('/sementes/ubs'), visible: false,
        },
        {
          label: 'Pessoas', icon: 'fas fa-users', ...classNameAndTo('/geral/pessoas'), visible: false,
        },
        {
          label: 'Campos Produção', icon: 'pi pi-fw pi-align-justify', ...classNameAndTo('/sementes/campos_producao'), visible: false,
        },
        {
          label: 'Peneiras', icon: 'pi pi-fw pi-sliders-h', ...classNameAndTo('/sementes/peneiras'), visible: false,
        },
        {
          label: 'Depósitos', icon: 'pi pi-fw pi-table', ...classNameAndTo('/estoque/depositos'), visible: false,
        },
        {
          label: 'Armazéns', icon: 'fas fa-warehouse', ...classNameAndTo('/sementes/armazens'), visible: false,
        },
        {
          label: 'Itens de estoque', icon: 'fas fa-boxes', ...classNameAndTo('/estoque/itens'), visible: false,
        },
        {
          label: 'Registros Excluídos', icon: 'pi pi-fw pi-info-circle', ...classNameAndTo('/geral/auditorias'), visible: false,
        },
      ],
    },
    {
      label: 'Beneficiamento de Sementes',
      icon: 'pi pi-fw pi-sitemap',
      visible: false,
      items: [
        {
          label: 'Planejamentos', icon: 'pi pi-fw pi-book', ...classNameAndTo('/sementes/planejamentos'), visible: false,
        },
        {
          label: 'Lotes', icon: 'pi pi-fw pi-th-large', ...classNameAndTo('/sementes/lotes'), visible: false,
        },
        {
          label: 'Movimentação no armazém', icon: 'fas fa-exchange-alt', ...classNameAndTo('/sementes/lotes/localizacao'), visible: false,
        },
        {
          label: 'Subproduto', icon: 'pi pi-fw pi-inbox', ...classNameAndTo('/sementes/subproduto'), visible: false,
        },
        {
          label: 'Vínculo de lotes', icon: 'fas fa-bezier-curve', ...classNameAndTo('/sementes/vinculo-lotes-campos'), visible: false,
        },
        {
          label: 'Reembalagens', icon: 'fas fa-cubes', ...classNameAndTo('/sementes/reembalagens'), visible: false,
        },
      ],
    },
    {
      label: 'Laboratório',
      icon: 'fas fa-diagnoses',
      visible: true,
      items: [
        {
          label: 'Equipamentos', icon: 'fas fa-microscope', ...classNameAndTo('/sementes/equipamentos'), visible: false,
        },
        {
          label: 'Sementes', icon: 'fas fa-seedling', ...classNameAndTo('/sementes'), visible: true,
        },
      ],
    },
    {
      label: 'Admin',
      icon: 'pi pi-fw pi-cog',
      visible: isAdmin,
      items: [
        {
          label: 'Relatório template', icon: 'fas fa-file-invoice', ...classNameAndTo('/geral/relatorio_template'), visible: isAdmin,
        },
        {
          label: 'Relatório scripts', icon: 'fas fa-file-code', ...classNameAndTo('/geral/relatorio_script'), visible: isAdmin,
        },
      ],
    },
  ];

  const isExpanded = useSelector(selectSidebarActive);

  const setExpanded = (menuItems: MenuItem[]): MenuItem[] => (
    map(menuItems, (item) => (
      { ...item, expanded: !!find(item.items, (it: MenuItem) => urlMatches(it.to)) }
    ))
  );

  const renderCollapsedMenuItem = (item: any, isSubmenu = false) => {
    if (!item.visible) return null;

    // Se tem subitens, renderizar como grupo
    if (item.items) {
      return (
        <div key={item.label} className="sidebar-menu-group">
          {item.items.map((subitem: any) => renderCollapsedMenuItem(subitem, true))}
        </div>
      );
    }

    // Item de menu simples
    return (
      <Link
        key={item.label}
        to={item.to}
        className={`sidebar-menu-item ${
          isSubmenu ? 'sidebar-menu-item--submenu' : ''
        } ${item.className || ''}`}
        title={item.label}
      >
        <i className={item.icon} />
      </Link>
    );
  };

  if (isExpanded) {
    // Sidebar expandida: usar MultiNivelMenu (colapsável)
    return <MultiNivelMenu model={setExpanded(items)} />;
  }

  // Sidebar colapsada: menu simples apenas com ícones
  return (
    <nav className="sidebar-menu">
      {items.map((item) => renderCollapsedMenuItem(item))}
    </nav>
  );
};

export default MainMenu;
